export class GitProvidersProject {
    constructor(model) {
        this.id = model.id;
        this.name = model.name;
        this.url = model.url;
        this.slug = model.slug;
    }
}
export class GitProvidersProjects {
    constructor(model) {
        this.projects = model.projects.map((project) => new GitProvidersProject(project));
    }
}
